import SubPanel from './SubPanel';

export default SubPanel;

export type { ISubPanelProps, SubPanelTone } from './SubPanel';
